'use strict';
module.exports = require('./FileUpload.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/fileupload/index.js
// module id = 1525
// module chunks = 1